import { useQuery } from "@tanstack/react-query";
import { getSequenceObjectives } from "@/app/actions/messages-content/objectives/action";
import { QueryKey } from "@/app/vars/QueryKeys";

type Options = {
  avatarId?: number;
  enabled?: boolean;
};

export function buildSequenceObjectivesQueryKey(avatarId: number) {
  return [QueryKey.SEQUENCE_OBJECTIVE, avatarId];
}

export function useFetchSequenceObjectives(options: Options) {
  const { avatarId, enabled = true } = options;

  return useQuery({
    queryKey: [QueryKey.SEQUENCE_OBJECTIVE, avatarId],
    queryFn: () => getSequenceObjectives(avatarId!),
    enabled: enabled && !!avatarId,
    staleTime: Infinity,
  });
}
